import React from "react";
import { Avatar, Button, IconButton, Tooltip } from "@mui/material";
import { EditNote, PersonRemove } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FollowedPlayerCard = ({ player, onEditNotes, onUnfollow }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("scouting");
  const followedDate = player.followedAt ? new Date(player.followedAt) : null;
  const stats = [
    ["partidosJugados", "matches"],
    ["titularidades", "starters"],
    ["goles", "goals"],
    ["minutosJugados", "minutes"],
  ].filter(([key]) => player[key] != null);

  return (
    <article className="sc-player sc-panel">
      <div className="sc-player-identity">
        <Avatar className="sc-player-avatar">
          {player.jugadorNombre?.charAt(0)?.toUpperCase() || "?"}
        </Avatar>
        <div>
          <h3>
            <button type="button" className="sc-player-link" onClick={() => navigate(`/jugador?id=${player.jugadorId}`)}>
              {player.jugadorNombre}
            </button>
          </h3>
          <p>{player.equipoNombre || t("components.comparison.noTeam")}</p>
        </div>
        <Tooltip title={t("players.unfollow")}>
          <IconButton aria-label={`${t("players.unfollow")}: ${player.jugadorNombre}`} onClick={() => onUnfollow(player)} className="sc-unfollow">
            <PersonRemove fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
      {stats.length > 0 && (
        <dl className="sc-player-stats">
          {stats.map(([key, label]) => (
            <div key={key}>
              <dt>{t(`components.trends.metric.${label}`)}</dt>
              <dd>{player[key]}</dd>
            </div>
          ))}
        </dl>
      )}
      {(player.tags?.length > 0 || player.posiciones?.length > 0 || player.pieDominante) && (
        <div className="sc-player-tags">
          {player.posiciones?.map((position) => <span key={`position-${position}`}>{position}</span>)}
          {player.pieDominante && <span>{t("workspace.foot")}: {player.pieDominante}</span>}
          {player.tags?.map((tag) => <span key={`tag-${tag}`}>{tag}</span>)}
        </div>
      )}
      {player.notes && <p className="sc-player-excerpt">{player.notes}</p>}
      <div className="sc-player-footer">
        <span>
          {t("workspace.followedSince")}{" "}
          {followedDate && !Number.isNaN(followedDate.getTime()) ? followedDate.toLocaleDateString(i18n.language) : t("matchCard.noDate")}
        </span>
        <Button startIcon={<EditNote />} onClick={() => onEditNotes(player)}>
          {t("workspace.editNotes")}
        </Button>
      </div>
    </article>
  );
};

export default FollowedPlayerCard;
